const ColorSwatch = require('./ColorSwatch');

module.exports = ColorSwatch;
